<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jIMT7x/tc-custom/9781626816718.jpg?1699984721388" alt="This image is the cover for the book Texas Gamble, The Texas Star Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Texas Gamble, The Texas Star Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>A Mexican rancher’s daughter takes a gamble on love to save her father’s land in this historical western romance by the author of <i>Texas Dawn</i>.</b><br/>  <br/><i>Nueces Strip, 1839</i>. Serita Cortinas will do anything to save her father’s ranch on the contested lands between Texas and Mexico. She’ll even allow herself to be gambled away in her father’s card game. The man to win her hand isn’t the groom of her dreams—he’s arrogant and brooding. But as it turns out, Captain Giddeon Duval may be exactly what Serita needs to ward off the threat of gringo land raiders.<br/>  <br/> Giddeon isn’t looking for a wife when he sits down at the card table. All he wants is enough money to salvage his sailing ship. But when his lucky hand wins him the spirited Serita, the undeniable desire he feels for the spirited beauty overtakes him. He realizes he’ll do whatever it takes to vanquish her enemies—and conquer her heart as well.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Vivian Vaughan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?091a4e1a